<template>
  <div class="title-icon">
    <div class="icon-m"></div>
    <span>{{text}}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: { default: '' }
  }
}
</script>

<style lang="less" scoped>
.title-icon{
  height: 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  span{
    line-height: 22px;
    color: @text-color-base;
    font-weight: bold;
  }
}
.icon-m{
  width: 12px;
  height: 12px;
  border-right: 2px solid #d21d12;
  border-bottom: 2px solid #d21d12;
  margin-right: 14px;
}
</style>
